import { render, staticRenderFns } from "./Bulk.vue?vue&type=template&id=58767110&"
import script from "./Bulk.vue?vue&type=script&lang=js&"
export * from "./Bulk.vue?vue&type=script&lang=js&"
import style0 from "./Bulk.vue?vue&type=style&index=0&id=58767110&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports